define('home/templates/profileCardPost',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<span class=\"icon-forward\"></span>\n"
    + ((stack1 = container.invokePartial(partials.userName,(depth0 != null ? depth0.replyAuthor : depth0),{"name":"userName","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"3":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"spacing-bottom-small\">\n<span class=\"label label-danger\">"
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.hiddenExplanation : depth0), depth0))
    + "</span>\n"
    + ((stack1 = container.invokePartial(partials.spamActions,depth0,{"name":"spamActions","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "</div>\n";
},"5":function(container,depth0,helpers,partials,data) {
    return "hidden";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : {}, alias2=container.lambda, alias3=container.escapeExpression;

  return ((stack1 = container.invokePartial(partials.userAvatar,(depth0 != null ? depth0.author : depth0),{"name":"userAvatar","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "<div class=\"comment-body\">\n<header class=\"comment-header\">\n<div class=\"align-min-tablet\">\n<div class=\"spacing-right\">\n"
    + ((stack1 = container.invokePartial(partials.userName,(depth0 != null ? depth0.author : depth0),{"name":"userName","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.replyAuthor : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "<a class=\"link-gray time\"\nhref=\""
    + alias3(alias2((depth0 != null ? depth0.discussionRoute : depth0), depth0))
    + "#comment-"
    + alias3(alias2((depth0 != null ? depth0.id : depth0), depth0))
    + "\"\ndata-link-name=\"timestamp\"\ndata-thread-id=\""
    + alias3(alias2(((stack1 = (depth0 != null ? depth0.thread : depth0)) != null ? stack1.id : stack1), depth0))
    + "\">\n"
    + alias3(alias2((depth0 != null ? depth0.relativeTime : depth0), depth0))
    + "\n</a>\n</div>\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isHidden : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n</header>\n<div data-role=\"post-content\"></div>\n<footer class=\"comment-actions "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isHidden : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\" data-role=\"post-actions\">\n</footer>\n</div>\n";
},"usePartial":true,"useData":true})

});
